// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery } from '@tanstack/react-query';
import { useCNTokenMetadataApiClient } from '../../contexts/CNTokenMetadataApiContext';

export const useCNGetRegistryAdminId = () => {
  const tokenMetadataClient = useCNTokenMetadataApiClient();

  return useQuery({
    queryKey: [tokenMetadataClient, 'getCNRegistryInfo'],
    queryFn: () =>
      tokenMetadataClient.getRegistryInfo().then((result) => {
        return result.adminId;
      }),
    refetchInterval: false,
  });
};
